import { axiosCashJournalClient } from "./api";
import { GCS_BUCKET_NAME, GCS_URL } from "./config";

export interface DocumentFetchBodyI {
  file_name: string,
  path_file: string,
  id?: number,
  trx_id?: string,
  item_id?: number,
  source_file?: string,
  source_key?: string,
  file_size?: string,
  create_at?: string,
  create_by?: string,
}

export const url = "bb-one/gcs/v1/sign-url";

const generateMime = (extension: "jpg" | "jpeg" | "jpe" | "png" | "pdf") => {
  const mimeTypes = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    jpe: "image/jpeg",
    png: "image/png",
    pdf: "application/pdf",
  };
  return mimeTypes[extension] || "";
};

export const getDocUrl = async (
  payload: DocumentFetchBodyI,
): Promise<string> => {
  const extension = payload.file_name.split(".").pop()?.toLowerCase() as "jpg" | "jpeg" | "jpe" | "png" | "pdf";
  const data = {
    bucket_name: GCS_BUCKET_NAME,
    folder_name: payload.path_file,
    file_name: payload.file_name,
    content_type: generateMime(extension),
    is_encrypted: true,
  };

  const { data: { signUrl } } = await axiosCashJournalClient({
    method: "POST",
    url,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });

  const docUrl = `${GCS_URL}?url=${signUrl}`;
  return docUrl;
};
